const i18n = {
	labels: {
		1: [
			'Заголовок новости',
			'Изображение новости',
			'Текст новости'
		],
		0: [
			'Загаловак навіны',
			'Малюнак навіны',
			'Тэкст навіны'
		]
	},
	headerNewsMainPage: {
		1 : ["Новости"],
		0 : ["Навіны"]
	},
	newsShow: {
		1 : ['Все новости'],
		0 : ['Усе Навіны']
	},
	noticeImage: {
		1 : ["Пожалуйста, добавьте изображение новости"],
		0 : ["Калі ласка, дадайце малюнак навіны"]
	},
	askDeleteNews: {
		1 : ["Вы уверены, что хотите удалить новость?"],
		0 : ["Вы ўпэўнены, што жадаеце выдаліць навіну?"]
	},
	noticeDeleteNews: {
		1 : ["Новость успешно удалена!"],
		0 : ["Навіна паспяхова выдалена!"]
	},
	headerNewsMain: {
		1 : ["Новости"],
		0 : ["Навіны"]
	},
	noticeEditNews: {
		1 : ["Новость успешно изменена!"],
		0 : ["Навіна паспяхова зменена!"]
	},
	noticeCreateNews: {
		1 : ["Новость успешно добавлена!"],
		0 : ["Навіна паспяхова дабаўлена!"]
	},
	emptyNews: {
		1 : ["Нет новостей"],
		0 : ["Няма навін"]
	},
	emptyNewsSearch: {
		1 : ["По Вашему запросу нет новостей"],
		0 : ["Па Вашым запыце няма навін"]
	},
	uploadField: {
		1 : ["Загрузить"],
		0 : ["Загрузіць"]
	},
	pleaseEnterRequire: {
		1 : "Пожалуйста, заполните поле '${label}'",
		0 : "Калі ласка, запоўніце поле '${label}'"
	},
	pleaseEnter: {
		1 : ["Пожалуйста, заполните поле", "непробельными символами"],
		0 : ["Калі ласка, запоўніце поле", "непрабельнымі сімваламі"]
	},
	rangeLocale: {
		1 : ["Длина поля '${label}' ${min} - ${max} символов"],
		0 : ["Даўжыня поля '${label}' ${min} - ${max} сімвалаў"]
	},
	mainEditNews: {
		1 : ["Редактирование новости"],
		0 : ["Змена навіны"]
	},
	mainAddNews: {
		1 : ["Добавление новости"],
		0 : ["Дабаўленне навіны"]
	},
	lastHeaderNews: {
		1 : ["Другие новости"],
		0 : ["Іншыя навіны"]
	},
	managingNews: {
		1 : ["Управление новостями системы обращений"],
		0 : ["Упраўленне навінамі сістэмы зваротаў"]
	},
	addNewsButton: {
		1 : ["Добавить новость"],
		0 : ["Дабавіць навіну"]
	},
	changeNewsButton: {
		1 : ["Сохранить новость"],
		0 : ["Захаваць навіну"]
	},
	downloadFileRulesInfo: {
		1 : `Для загрузки доступны файлы  форматов ".jpg", ".png", размером до {0}МБ `,
		0 : `Для загрузкі даступныя файлы фарматаў ".jpg", ".png ", памерам да {0}МБ`
	},
	downloadFileSizeError: {
		1 : `Размер файла больше {0}МБ`,
		0 : `Памер файла больш чым {0}МБ`
	},
	downloadFileTypeError: {
		1 : `Недоступный формат файла`,
		0 : `Недаступны фармат файла`
	},
	userEmail: {
		1 : "E-mail пользователя",
		0 : "E-mail карыстальніка"
	}

}
export default i18n
